import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChooseUserComponent } from '@bca-company-data/company-data/choose-user/choose-user.component';
import { CompanyDataComponent } from '@bca-company-data/company-data/company-data.component';
import { CompanyEmployeesComponent } from '@bca-company-data/company-data/company-employees/company-employees.component';
import { CompanySearchComponent } from '@bca-company-data/company-data/company-search/company-search.component';
import { UserFormComponent } from '@bca-company-data/company-data/user-form/user-form.component';
import { TypeAheadModule } from '@bca-shared/modules/type-ahead/type-ahead.module';
import { SharedModule } from '@bca-shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    CompanyDataComponent,
    UserFormComponent,
    ChooseUserComponent,
    CompanySearchComponent,
    CompanyEmployeesComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    TypeAheadModule,
    TranslateModule.forChild()
  ],
  exports: [CompanyDataComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CompanyDataModule {}
